<script setup lang="ts">
import { inject, ref } from 'vue'
import PageTitle from '@/components/PageTitle.vue'
import { customElementPropsKey } from '@/types/customElementProps.types'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const templateProps = inject(customElementPropsKey)
const formIsValid = ref(false)
const email = ref(templateProps?.email)
const firstname = ref(templateProps?.firstname)
const lastname = ref(templateProps?.lastname)

const requiredRule = (v: string) => !!v || t('error.field.required')

// https://regexr.com/3e48o
const emailRule = (v: string) =>
  /^[\w-\.\+]+@([\w-]+\.)+[\w-]{2,4}$/.test(v) || t('error.email.invalid')
</script>

<template>
  <div>
    <PageTitle :title="$t('update-profile.card.title')" />

    <v-form
      v-model="formIsValid"
      :action="templateProps?.loginActionUrl"
      method="post"
      novalidate
      class="my-6"
    >
      <!--
            We send an empty username when creating a new SAML user
            and will overwrite it later with the GLOBAL_USER_ID created by Accounts
          -->
      <input type="hidden" name="username" :value="''" />

      <v-input>
        <v-text-field
          v-model="email"
          type="email"
          autofocus
          name="email"
          autocomplete="email"
          :label="$t('update-profile.email.label')"
          :rules="[requiredRule, emailRule]"
        />
      </v-input>

      <v-input>
        <v-text-field
          v-model="firstname"
          type="text"
          name="firstName"
          autocomplete="firstname"
          :label="$t('update-profile.firstname.label')"
          :rules="[requiredRule]"
        />
      </v-input>

      <v-input>
        <v-text-field
          v-model="lastname"
          type="text"
          name="lastName"
          autocomplete="lastname"
          :label="$t('update-profile.lastname.label')"
          :rules="[requiredRule]"
        />
      </v-input>

      <v-input>
        <v-btn block type="submit" :disabled="!formIsValid">{{
          $t('update-profile.submit.button')
        }}</v-btn>
      </v-input>
    </v-form>
  </div>
</template>
